// FILTER SELECTED MASK
const getMask = (mask, e) => {
  if (mask === 'cnpj') cnpjMask(e)
  if (mask === 'cpf') cpfMask(e)
  if (mask === 'cep') cepMask(e)
  if (mask === 'phone') phoneMask(e)
  if (mask === 'cellphone') cellphoneMask(e)
  if (mask === 'rg') rgMask(e)
  if (mask === 'currency') currencyMask(e)
}

// APPLY MASK ON TEXT
const applyMask = (mask: string, text: string) => {
  if (mask === 'cnpj') applyCnpj(text)
}

// MASK TYPES
const cnpjMask = (e) => {
  e.target.maxLength = 18
  let value = e.target.value
  value = value.replace(/\D/g, '')
  value = value.replace(/^(\d{2})(\d{1})/, '$1.$2')
  value = value.replace(/^(\d{2}).(\d{3})(\d{1})/, '$1.$2.$3')
  value = value.replace(/^(\d{2}).(\d{3}).(\d{3})(\d{1})/, '$1.$2.$3/$4')
  value = value.replace(
    /^(\d{2}).(\d{3}).(\d{3})[/](\d{4})(\d)/,
    '$1.$2.$3/$4-$5'
  )
  e.target.value = value
}

const applyCnpj = (value) => {
  value = value.replace(/\D/g, '')
  value = value.replace(/^(\d{2})(\d{1})/, '$1.$2')
  value = value.replace(/^(\d{2}).(\d{3})(\d{1})/, '$1.$2.$3')
  value = value.replace(/^(\d{2}).(\d{3}).(\d{3})(\d{1})/, '$1.$2.$3/$4')
  value = value.replace(
    /^(\d{2}).(\d{3}).(\d{3})[/](\d{4})(\d)/,
    '$1.$2.$3/$4-$5'
  )
  return value
}

const cpfMask = (e) => {
  e.target.maxLength = 14
  let value = e.target.value
  value = value.replace(/\D/g, '')
  value = value.replace(/^(\d{3})(\d{1})/, '$1.$2')
  value = value.replace(/^(\d{3}).(\d{3})(\d{1})/, '$1.$2.$3')
  value = value.replace(/^(\d{3}).(\d{3}).(\d{3})(\d)/, '$1.$2.$3-$4')
  e.target.value = value
}

const cepMask = (e) => {
  e.target.maxLength = 9
  let value = e.target.value
  value = value.replace(/\D/g, '')
  value = value.replace(/^(\d{5})(\d{1})/, '$1-$2')
  e.target.value = value
}

const phoneMask = (e) => {
  e.target.maxLength = 14
  let value = e.target.value
  value = value.replace(/\D/g, '')
  value = value.replace(/^(\d{1})/, '($1')
  value = value.replace(/^[(](\d{2})(\d{1})/, '($1) $2')
  value = value.replace(/^[(](\d{2})[)][ ](\d{4})(\d{1})/, '($1) $2-$3')
  e.target.value = value
}

const cellphoneMask = (e) => {
  e.target.maxLength = 15
  let value = e.target.value
  value = value.replace(/\D/g, '')
  value = value.replace(/^(\d{1})/, '($1')
  value = value.replace(/^[(](\d{2})(\d{1})/, '($1) $2')
  value = value.replace(/^[(](\d{2})[)][ ](\d{5})(\d{1})/, '($1) $2-$3')
  e.target.value = value
}

const rgMask = (e) => {
  e.target.maxLength = 14
  let value = e.target.value
  value = value.replace(/[^a-z\d]/, '')
  e.target.value = value
}

const currencyMask = (e) => {
  e.target.value = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'currency'
  }).format(e.target.value)
}

// UNMASK
const unmask = (value) =>
  value.split('.').join('').split('-').join('').split('/').join('')

export { getMask, unmask, applyMask }
